import { useEffect, useState } from 'react';
import { useBasicInfo } from '@/src/listings/components/_shared/contexts/BasicInfoContext';
import { useDisplayStatus } from '@/src/listings/components/_shared/contexts/DisplayStatusContext';
import { useTicketInformation } from '@/src/listings/hooks/useTicketInformation/useTicketInformation';
import { updateRsvpPageProperty } from '@/src/listings/utils/dataLayer';
import { QUERY_PARAMS } from '@/src/listings/common/constants';
import { shouldDisplayRsvp as computeShouldDisplayRsvp } from '../utils';
import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { isCampaignTokenValid } from '../RSVP/rsvpApiClient';

export interface RsvpParamsState {
  mipaToken: string | null;
}

export const useShouldDisplayRsvp = () => {
  const [rsvpParams, setUrlParams] = useState<RsvpParamsState>({
    mipaToken: null,
  });

  const { id: eventId, status } = useBasicInfo();
  const { displayStatus } = useDisplayStatus();
  const [ticketInfo] = useTicketInformation();

  useEffect(() => {
    const verifyMipaToken = async () => {
      if (!HAS_WINDOW) return;
      const params = new URLSearchParams(window.location.search);
      const mipaToken = params.get(QUERY_PARAMS.MIPA);

      if (!mipaToken) {
        return;
      }

      const isMipaTokenValid = await isCampaignTokenValid(eventId, mipaToken);
      updateRsvpPageProperty(isMipaTokenValid);
      if (isMipaTokenValid) {
        setUrlParams({
          mipaToken: mipaToken,
        });
      }
    };
    verifyMipaToken();
  }, [eventId]);

  const shouldDisplayRsvp = computeShouldDisplayRsvp(rsvpParams.mipaToken, status, displayStatus, ticketInfo);

  return {
    shouldDisplayRsvp,
    mipaToken: rsvpParams.mipaToken,
  };
};
